import { cn } from '@util/cn'
import { ReactNode } from 'react'

type Props = {
  className?: string
  icon?: ReactNode
  title?: ReactNode
  children: ReactNode
}
export function FullScreenNoticePage({ className, children, title, icon }: Props) {
  return (
    <div
      className={cn(
        'absolute bottom-0 left-0 right-0 top-0 flex flex-col items-center justify-center gap-4',
        className
      )}
    >
      {icon}
      {title ? <h1 className="text-center text-2xl font-bold">{title}</h1> : null}
      {children}
    </div>
  )
}
